import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Breadcrumb } from 'react-breadcrumbs';
import { Route, withRouter, NavLink } from 'react-router-dom';
import { setLanguage } from 'redux-i18n';
import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module';

function routeLanguageSwitcher(route, translations, currentLanguage, newLanguage) {
  var reverseRoutes = {};
  Object.keys(translations[currentLanguage]).filter(function (translationKey) {
    return translationKey.includes('routes');
  }).forEach(function (key) {
    return reverseRoutes[translations[currentLanguage][key]] = key;
  });

  var translatedRoute = route.split('/').map(function (routePart) {
    if (!reverseRoutes[routePart]) {
      return routePart;
    }

    var translationPath = reverseRoutes[routePart];
    var translatedRoutePart = translations[newLanguage][translationPath];

    if (!translatedRoutePart) {
      return routePart;
    }

    return translatedRoutePart;
  });

  return '/' + translatedRoute.filter(Boolean).join('/');
}

function translateRoute(route, t) {
  var translatedRoute = route.split('/').map(function (routePart) {
    var translationPath = 'routes.' + routePart;
    var translatedRoutePart = t(translationPath);

    if (!translatedRoutePart || translatedRoutePart === translationPath) {
      return routePart;
    }

    return translatedRoutePart;
  });

  return '/' + translatedRoute.filter(Boolean).join('/');
}

var translateBreadcrumb = (function (breadcrumb, t) {
  var breadcrumbPath = "breadcrumbs." + breadcrumb;
  var translatedBreadcrumbPart = t(breadcrumbPath);

  if (!translatedBreadcrumbPart || translatedBreadcrumbPart === breadcrumbPath) {
    return breadcrumb;
  }

  return translatedBreadcrumbPart;
});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function CrumbRoute(_ref, _ref2) {
  var t = _ref2.t;
  var Component$$1 = _ref.component,
      path = _ref.path,
      title = _ref.title,
      _render = _ref.render,
      props = objectWithoutProperties(_ref, ['component', 'path', 'title', 'render']);

  return React.createElement(Route, _extends({}, props, {
    path: translateRoute(path, t),
    render: function render(routeProps) {
      return React.createElement(
        Breadcrumb,
        { data: {
            title: translateBreadcrumb(title, t),
            pathname: routeProps.match.url
          }
        },
        Component$$1 ? React.createElement(Component$$1, routeProps) : _render(_extends({}, routeProps, { path: path }))
      );
    }
  }));
}

CrumbRoute.contextTypes = {
  t: PropTypes.func
};

CrumbRoute.defaultProps = {
  component: false,
  render: false
};

CrumbRoute.propTypes = {
  lang: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.bool]),
  render: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.bool])
};

function mapStateToProps(state) {
  return {
    lang: state.i18nState.lang
  };
}

var CrumbRoute$1 = withRouter(connect(mapStateToProps)(CrumbRoute));

var BaseRoute = function (_Component) {
  inherits(BaseRoute, _Component);

  function BaseRoute() {
    classCallCheck(this, BaseRoute);
    return possibleConstructorReturn(this, (BaseRoute.__proto__ || Object.getPrototypeOf(BaseRoute)).apply(this, arguments));
  }

  createClass(BaseRoute, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          location = _props.location,
          history = _props.history;


      this.setLanguageFromUrl(location);
      history.listen(this.setLanguageFromUrl.bind(this));
    }
  }, {
    key: 'setLanguageFromUrl',
    value: function setLanguageFromUrl(_ref) {
      var pathname = _ref.pathname;
      var _props2 = this.props,
          history = _props2.history,
          dispatch = _props2.dispatch,
          lang = _props2.lang;
      var _context = this.context,
          cookies = _context.cookies,
          availableLanguages = _context.availableLanguages,
          defaultLanguage = _context.defaultLanguage,
          response = _context.response;

      var language = pathname.split('/').filter(Boolean)[0];
      var isAvailableLanguage = availableLanguages.includes(language);

      if (!isAvailableLanguage) {
        if (response) {
          response.redirect('/' + (cookies.get('lang') || defaultLanguage));
        } else {
          history.push('/' + (cookies.get('lang') || defaultLanguage));
        }

        dispatch(setLanguage(cookies.get('lang') || defaultLanguage));
      } else if (lang !== language) {
        dispatch(setLanguage(language));
        cookies.set('lang', language, {
          path: '/' + process.env.REACT_APP_REGION_DEFAULT_LOCALE
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var component = this.props.component;

      return React.createElement(CrumbRoute$1, { path: '/en', title: 'home', component: component });
    }
  }]);
  return BaseRoute;
}(Component);

function mapStateToProps$1(state) {
  return {
    lang: state.i18nState.lang
  };
}

BaseRoute.contextTypes = {
  availableLanguages: PropTypes.array,
  defaultLanguage: PropTypes.string,
  cookies: PropTypes.object,
  response: PropTypes.object
};

BaseRoute.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired
};

var BaseRoute$1 = withRouter(connect(mapStateToProps$1)(BaseRoute));

var LangRoute = function (_Component) {
  inherits(LangRoute, _Component);

  function LangRoute() {
    classCallCheck(this, LangRoute);
    return possibleConstructorReturn(this, (LangRoute.__proto__ || Object.getPrototypeOf(LangRoute)).apply(this, arguments));
  }

  createClass(LangRoute, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          location = _props.location,
          history = _props.history;


      this.setLanguageFromUrl(location);
      history.listen(this.setLanguageFromUrl.bind(this));
    }
  }, {
    key: 'setLanguageFromUrl',
    value: function setLanguageFromUrl(_ref) {
      var pathname = _ref.pathname;
      var _props2 = this.props,
          history = _props2.history,
          dispatch = _props2.dispatch,
          lang = _props2.lang;
      var _context = this.context,
          cookies = _context.cookies,
          availableLanguages = _context.availableLanguages,
          defaultLanguage = _context.defaultLanguage,
          response = _context.response;

      var language = pathname.split('/').filter(Boolean)[0];
      var isAvailableLanguage = availableLanguages.includes(language);

      if (!isAvailableLanguage) {
        if (response) {
          response.redirect('/' + (cookies.get('lang') || defaultLanguage));
        } else {
          history.push('/' + (cookies.get('lang') || defaultLanguage));
        }

        dispatch(setLanguage(cookies.get('lang') || defaultLanguage));
      } else if (lang !== language) {
        dispatch(setLanguage(language));
        cookies.set('lang', language, {
          path: '/' + process.env.REACT_APP_REGION_DEFAULT_LOCALE
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(Route, this.props);
    }
  }]);
  return LangRoute;
}(Component);

function mapStateToProps$2(state) {
  return {
    lang: state.i18nState.lang
  };
}

LangRoute.contextTypes = {
  availableLanguages: PropTypes.array,
  defaultLanguage: PropTypes.string,
  cookies: PropTypes.object,
  response: PropTypes.object
};

LangRoute.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired
};

var LangRoute$1 = withRouter(connect(mapStateToProps$2)(LangRoute));

// version from response - first param, local version second param
var semverGreaterThan = function semverGreaterThan(versionA, versionB) {
  var versionsA = versionA.split(/\./g);

  var versionsB = versionB.split(/\./g);
  while (versionsA.length || versionsB.length) {
    var a = Number(versionsA.shift());

    var b = Number(versionsB.shift());
    // eslint-disable-next-line no-continue
    if (a === b) continue;
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b);
  }
  return false;
};

var CacheBuster = function (_Component) {
  inherits(CacheBuster, _Component);

  function CacheBuster(props) {
    classCallCheck(this, CacheBuster);

    var _this = possibleConstructorReturn(this, (CacheBuster.__proto__ || Object.getPrototypeOf(CacheBuster)).call(this, props));

    _this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: function refreshCacheAndReload() {
        console.log('Clearing cache and hard reloading...');
        if (caches) {
          // Service worker cache should be cleared with caches.delete()
          caches.keys().then(function (names) {
            // delete browser cache and hard reload
            Promise.all(names.map(function (cache) {
              return caches.delete(cache);
            })).then(function () {
              return window.location.reload();
            });
          });
        }
      }
    };
    return _this;
  }

  createClass(CacheBuster, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      fetch('/static/meta.json').then(function (response) {
        return response.json();
      }).then(function (meta) {
        var currentVersion = process.env.REACT_APP_CURRENT_APP_VERSION;
        var latestVersion = meta.version;

        if (latestVersion && currentVersion) {
          var shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
          if (shouldForceRefresh) {
            console.log('We have a new version - ' + latestVersion + '. Should force refresh');
            _this2.setState({ loading: false, isLatestVersion: false });
          } else {
            console.log('You already have the latest version - ' + latestVersion + '. No cache refresh needed.');
            _this2.setState({ loading: false, isLatestVersion: true });
          }
        }
      }).catch(function (errors) {
        if (window) window.console.log(errors);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          loading = _state.loading,
          isLatestVersion = _state.isLatestVersion,
          refreshCacheAndReload = _state.refreshCacheAndReload;
      var children = this.props.children;


      return children({ loading: loading, isLatestVersion: isLatestVersion, refreshCacheAndReload: refreshCacheAndReload });
    }
  }]);
  return CacheBuster;
}(Component);

CacheBuster.propTypes = {
  children: PropTypes.func.isRequired
};

// libs

var LanguageSwitcher = function (_Component) {
  inherits(LanguageSwitcher, _Component);

  function LanguageSwitcher() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, LanguageSwitcher);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = LanguageSwitcher.__proto__ || Object.getPrototypeOf(LanguageSwitcher)).call.apply(_ref, [this].concat(args))), _this), _this.state = { otherLanguages: [] }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(LanguageSwitcher, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var location = this.props.location;


      this.setOtherLanguagesFromUrl(location);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          lang = _props.lang,
          location = _props.location,
          pathname = _props.location.pathname;
      var prevLang = prevProps.lang,
          prevPathname = prevProps.location.pathname;


      if (lang !== prevLang || pathname !== prevPathname) {
        this.setOtherLanguagesFromUrl(location);
      }
    }
  }, {
    key: 'setOtherLanguagesFromUrl',
    value: function setOtherLanguagesFromUrl(_ref2) {
      var pathname = _ref2.pathname;
      var lang = this.props.lang;
      var _context = this.context,
          translations = _context.translations,
          availableLanguages = _context.availableLanguages;


      this.setState({
        otherLanguages: availableLanguages.filter(function (language) {
          return language !== lang;
        }).map(function (language) {
          return {
            language: language,
            pathname: routeLanguageSwitcher(pathname, translations, lang, language)
          };
        })
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;
      var otherLanguages = this.state.otherLanguages;
      var t = this.context.t;


      return React.createElement(
        'nav',
        { className: className },
        React.createElement(
          'ul',
          { className: 'links ' + className + '__links' },
          otherLanguages.map(function (_ref3) {
            var language = _ref3.language,
                pathname = _ref3.pathname;
            return React.createElement(
              'li',
              { className: 'link ' + className + '__link', key: language },
              React.createElement(
                NavLink,
                { to: pathname },
                t('languageSwitcher.' + language)
              )
            );
          })
        )
      );
    }
  }]);
  return LanguageSwitcher;
}(Component);

function mapStateToProps$3(state) {
  return {
    lang: state.i18nState.lang
  };
}

LanguageSwitcher.contextTypes = {
  t: PropTypes.func,
  translations: PropTypes.object.isRequired,
  availableLanguages: PropTypes.array.isRequired,
  defaultLanguage: PropTypes.string.isRequired
};

LanguageSwitcher.defaultProps = {
  className: 'nav'
};

LanguageSwitcher.propTypes = {
  className: PropTypes.string,
  location: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired
};

var LanguageSwitcher$1 = withRouter(connect(mapStateToProps$3)(LanguageSwitcher));

// libs

var GAListener = function (_Component) {
  inherits(GAListener, _Component);

  function GAListener() {
    classCallCheck(this, GAListener);

    var _this = possibleConstructorReturn(this, (GAListener.__proto__ || Object.getPrototypeOf(GAListener)).call(this));

    _this.sendPageView = _this.sendPageView.bind(_this);
    return _this;
  }

  createClass(GAListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var history = this.context.router.history;

      var analyticsCode = process.env.REACT_APP_GOOGLE_ANALYTICS_UA;

      ReactGA.initialize(analyticsCode, { debug: false });
      ReactGA.pageview(window.location.pathname + window.location.search);

      this.sendPageView(history.location);
      history.listen(this.sendPageView);
    }
  }, {
    key: 'sendPageView',
    value: function sendPageView(location) {
      ReactGA.set({ page: location.pathname });
      ReactGA.pageview(location.pathname);
      return this;
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return children;
    }
  }]);
  return GAListener;
}(Component);

GAListener.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

GAListener.contextTypes = {
  router: PropTypes.object
};

var GAListener$1 = withRouter(connect()(GAListener));

// libs

var GTManager = function (_Component) {
  inherits(GTManager, _Component);

  function GTManager() {
    classCallCheck(this, GTManager);
    return possibleConstructorReturn(this, (GTManager.__proto__ || Object.getPrototypeOf(GTManager)).apply(this, arguments));
  }

  createClass(GTManager, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var tagManagerId = process.env.REACT_APP_TAG_MANAGER_ID;
      var tagManagerArgs = {
        gtmId: tagManagerId
      };

      TagManager.initialize(tagManagerArgs);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return children;
    }
  }]);
  return GTManager;
}(Component);

GTManager.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

GTManager.contextTypes = {
  router: PropTypes.object
};

var GTManager$1 = withRouter(connect()(GTManager));

// libs

function TranslatedNavLink(_ref, _ref2) {
  var to = _ref.to,
      children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick;
  var t = _ref2.t;

  return React.createElement(
    NavLink,
    { className: className, onClick: onClick, to: translateRoute(to, t) },
    children
  );
}

TranslatedNavLink.contextTypes = {
  t: PropTypes.func
};

TranslatedNavLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.string.isRequired
};

TranslatedNavLink.defaultProps = {
  className: '',
  onClick: function onClick() {}
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document) && _isObject(document.createElement);
var _domCreate = function (it) {
  return is ? document.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var _redefine = createCommonjsModule(function (module) {
var SRC = _uid('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

_core.inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === _global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    _hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    _hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});
});

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // extend global
    if (target) _redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) _hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
_global.core = _core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

var max = Math.max;
var min = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
_export(_export.S + _export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (_toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.15 ToLength

var min$1 = Math.min;
var _toLength = function (it) {
  return it > 0 ? min$1(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

_export(_export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = _toIobject(callSite.raw);
    var len = _toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});

var _stringWs = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var space = '[' + _stringWs + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = _fails(function () {
    return !!_stringWs[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : _stringWs[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  _export(_export.P + _export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(_defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

var _stringTrim = exporter;

// 21.1.3.25 String.prototype.trim()
_stringTrim('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});

// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));
    var i = _toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _library = false;

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode: _library ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});
});

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$1 = _global.document;
var _html = document$1 && document$1.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$1 = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE$1 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

var def = _objectDp.f;

var TAG = _wks('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
  _setToStringTag(Constructor, NAME + ' Iterator');
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');
var ObjectProto = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

var ITERATOR = _wks('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (typeof IteratorPrototype[ITERATOR] != 'function') _hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if (BUGGY || VALUES_BUG || !proto[ITERATOR]) {
    _hide(proto, ITERATOR, $default);
  }
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

var $at$1 = _stringAt(false);
_export(_export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at$1(this, pos);
  }
});

// 7.2.8 IsRegExp(argument)


var MATCH = _wks('match');
var _isRegexp = function (it) {
  var isRegExp;
  return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == 'RegExp');
};

// helper for String#{startsWith, endsWith, includes}



var _stringContext = function (that, searchString, NAME) {
  if (_isRegexp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(_defined(that));
};

var MATCH$1 = _wks('match');
var _failsIsRegexp = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH$1] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

_export(_export.P + _export.F * _failsIsRegexp(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = _stringContext(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = _toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(_toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

var INCLUDES = 'includes';

_export(_export.P + _export.F * _failsIsRegexp(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~_stringContext(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var _stringRepeat = function repeat(count) {
  var str = String(_defined(this));
  var res = '';
  var n = _toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};

_export(_export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: _stringRepeat
});

var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

_export(_export.P + _export.F * _failsIsRegexp(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = _stringContext(this, searchString, STARTS_WITH);
    var index = _toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(_defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
var _stringHtml = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  _export(_export.P + _export.F * _fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

// B.2.3.2 String.prototype.anchor(name)
_stringHtml('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});

// B.2.3.3 String.prototype.big()
_stringHtml('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});

// B.2.3.4 String.prototype.blink()
_stringHtml('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});

// B.2.3.5 String.prototype.bold()
_stringHtml('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});

// B.2.3.6 String.prototype.fixed()
_stringHtml('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});

// B.2.3.7 String.prototype.fontcolor(color)
_stringHtml('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});

// B.2.3.8 String.prototype.fontsize(size)
_stringHtml('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});

// B.2.3.9 String.prototype.italics()
_stringHtml('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});

// B.2.3.10 String.prototype.link(url)
_stringHtml('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});

// B.2.3.11 String.prototype.small()
_stringHtml('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});

// B.2.3.12 String.prototype.strike()
_stringHtml('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});

// B.2.3.13 String.prototype.sub()
_stringHtml('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});

// B.2.3.14 String.prototype.sup()
_stringHtml('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});

var _fixReWks = function (KEY, length, exec) {
  var SYMBOL = _wks(KEY);
  var fns = exec(_defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (_fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    _redefine(String.prototype, KEY, strfn);
    _hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};

// @@match logic
_fixReWks('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});

// @@replace logic
_fixReWks('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});

// @@search logic
_fixReWks('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});

// @@split logic
_fixReWks('split', 2, function (defined, SPLIT, $split) {
  var isRegExp = _isRegexp;
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});

var string = _core.String;

var f$1 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$1
};

var gOPD = Object.getOwnPropertyDescriptor;

var f$2 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject(O);
  P = _toPrimitive(P, true);
  if (_ie8DomDefine) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
};

var _objectGopd = {
	f: f$2
};

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */


var check = function (O, proto) {
  _anObject(O);
  if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
var _setProto = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

var setPrototypeOf = _setProto.set;
var _inheritIfRequired = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && _isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal(O, hiddenKeys);
};

var _objectGopn = {
	f: f$3
};

// 21.2.5.3 get RegExp.prototype.flags

var _flags = function () {
  var that = _anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var SPECIES = _wks('species');

var _setSpecies = function (KEY) {
  var C = _global[KEY];
  if (_descriptors && C && !C[SPECIES]) _objectDp.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

var dP$1 = _objectDp.f;
var gOPN = _objectGopn.f;


var $RegExp = _global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (_descriptors && (!CORRECT_NEW || _fails(function () {
  re2[_wks('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = _isRegexp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : _inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? _flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP$1($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  _redefine(_global, 'RegExp', $RegExp);
}

_setSpecies('RegExp');

// 21.2.5.3 get RegExp.prototype.flags()
if (_descriptors && /./g.flags != 'g') _objectDp.f(RegExp.prototype, 'flags', {
  configurable: true,
  get: _flags
});

var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  _redefine(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (_fails(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = _anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !_descriptors && R instanceof RegExp ? _flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

var regexp = _core.RegExp;

// libs

// components

var Redirector = function (_Component) {
  inherits(Redirector, _Component);

  function Redirector(props) {
    classCallCheck(this, Redirector);

    var _this = possibleConstructorReturn(this, (Redirector.__proto__ || Object.getPrototypeOf(Redirector)).call(this));

    var redirects = props.redirects,
        pathname = props.history.location.pathname,
        history = props.history;

    if (redirects.length !== 0) {
      var currentRouteRedirect = redirects.sort(function (x, y) {
        if (x.parent && y.parent) {
          return 0;
        }
        if (!x.parent) {
          return -1;
        }
        return 1;
      }).find(function (path) {
        if (path.parent && (pathname.startsWith(path.from + '/') || pathname.endsWith(path.from) && pathname.startsWith(path.from))) {
          return path;
        }
        if (pathname === path.from) {
          return path;
        }
        return false;
      });
      if (currentRouteRedirect) {
        if (currentRouteRedirect.external && window) {
          window.location.href = currentRouteRedirect.to;
        } else if (currentRouteRedirect.parent) {
          var newPath = pathname.replace(currentRouteRedirect.from, currentRouteRedirect.to);
          history.push(newPath);
        } else {
          history.push(currentRouteRedirect.to);
        }
      }
    }
    return _this;
  }

  createClass(Redirector, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props = this.props,
          redirects = _props.redirects,
          pathname = _props.history.location.pathname,
          history = _props.history;

      if (redirects.length !== 0) {
        var currentRouteRedirect = redirects.sort(function (x, y) {
          if (x.parent && y.parent) {
            return 0;
          }
          if (!x.parent) {
            return -1;
          }
          return 1;
        }).find(function (path) {
          if (path.parent && (pathname.startsWith(path.from + '/') || pathname.endsWith(path.from) && pathname.startsWith(path.from))) {
            return path;
          }
          if (pathname === path.from) {
            return path;
          }
          return false;
        });
        if (currentRouteRedirect) {
          if (currentRouteRedirect.external && window) {
            window.location.href = currentRouteRedirect.to;
          } else if (currentRouteRedirect.parent) {
            var newPath = pathname.replace(currentRouteRedirect.from, currentRouteRedirect.to);
            history.push(newPath);
          } else {
            history.push(currentRouteRedirect.to);
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return children;
    }
  }]);
  return Redirector;
}(Component);

Redirector.contextTypes = {
  t: PropTypes.func
};

Redirector.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.bool]),
  history: PropTypes.object.isRequired,
  redirects: PropTypes.array.isRequired
};

Redirector.defaultProps = {
  children: false
};

var Redirector$1 = withRouter(connect()(Redirector));

// libs

function TranslatedRoute(_ref, _ref2) {
  var t = _ref2.t;
  var path = _ref.path,
      lang = _ref.lang,
      props = objectWithoutProperties(_ref, ['path', 'lang']);

  return React.createElement(Route, _extends({}, props, { path: translateRoute(path, t) }));
}

TranslatedRoute.contextTypes = {
  t: PropTypes.func
};

TranslatedRoute.propTypes = {
  lang: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired
};

function mapStateToProps$4(state) {
  return {
    lang: state.i18nState.lang
  };
}

var Route$1 = withRouter(connect(mapStateToProps$4)(TranslatedRoute));

function translatePath(path, t) {
  var translationPath = "routes." + path;
  var translatedPath = t(translationPath);
  return translatedPath === translationPath ? path : translatedPath;
}

var ValidateRoutes = function (_Component) {
  inherits(ValidateRoutes, _Component);

  function ValidateRoutes() {
    classCallCheck(this, ValidateRoutes);
    return possibleConstructorReturn(this, (ValidateRoutes.__proto__ || Object.getPrototypeOf(ValidateRoutes)).apply(this, arguments));
  }

  createClass(ValidateRoutes, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.validateCurrentPath();
    }
  }, {
    key: 'validateCurrentPath',
    value: function validateCurrentPath() {
      var _props = this.props,
          notFoundPath = _props.notFoundPath,
          history = _props.history;
      var t = this.context.t;

      var pathExist = this.currentPathExist();
      if (!pathExist) {
        var notFoundRoute = translateRoute(notFoundPath, t);
        history.push(notFoundRoute);
      }
    }
  }, {
    key: 'currentPathExist',
    value: function currentPathExist() {
      var _props2 = this.props,
          children = _props2.children,
          currentPath = _props2.location.pathname;
      var t = this.context.t;

      var translatedPaths = children.filter(function (child) {
        return child.type.name !== 'Redirector';
      }).map(function (_ref) {
        var _ref$props = _ref.props,
            path = _ref$props.path,
            exact = _ref$props.exact,
            hasChildren = _ref$props.hasChildren,
            withParams = _ref$props.withParams;
        return {
          translatedPath: translateRoute(path, t),
          exact: !exact ? false : exact,
          hasChildren: !hasChildren ? false : hasChildren,
          withParams: !withParams ? false : withParams
        };
      });
      var isValidPath = translatedPaths.map(function (_ref2) {
        var translatedPath = _ref2.translatedPath,
            exact = _ref2.exact,
            hasChildren = _ref2.hasChildren,
            withParams = _ref2.withParams;

        if (exact && translatedPath === currentPath || hasChildren && currentPath.includes(translatedPath + '/') || withParams && currentPath.includes('' + translatedPath.substr(0, translatedPath.lastIndexOf(':'))) || currentPath === translatedPath || currentPath === translatedPath + '/') {
          return true;
        }
        return false;
      });
      return isValidPath.indexOf(true) > -1;
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return children;
    }
  }]);
  return ValidateRoutes;
}(Component);

ValidateRoutes.contextTypes = {
  t: PropTypes.func
};

ValidateRoutes.defaultProps = {
  children: false,
  notFoundPath: '/en/notFound'
};

ValidateRoutes.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.bool]),
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  notFoundPath: PropTypes.string
};

function mapStateToProps$5(state) {
  return {
    lang: state.i18nState.lang
  };
}

var ValidateRoutes$1 = withRouter(connect(mapStateToProps$5)(ValidateRoutes));

export { BaseRoute$1 as BaseRoute, LangRoute$1 as LangRoute, CacheBuster, CrumbRoute$1 as CrumbRoute, LanguageSwitcher$1 as LanguageSwitcher, GAListener$1 as GAListener, GTManager$1 as GTManager, TranslatedNavLink as NavLink, Redirector$1 as Redirector, Route$1 as Route, translateRoute, translatePath, ValidateRoutes$1 as ValidateRoutes };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/o2web-react-core/dist/index.es.js
// module id = 26
// module chunks = 1